module.exports = {
    longboarding: require('./road-slope'),
    skatepark: require('./skate-park'),
    slope: require('./slope'),
    resort: require('./ski-resort'),
    basejumping: require('./basejumping'),
    surfing: require('./surfing'),
    diving: require('./diving'),
    moto: require('./moto'),
    mototrial: require('./mototrial'),
    snowmobile: require('./snowmobile'),
    wingsuit: require('./wingsuit'),
    flag: require('./place')
}